/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { requestText, type RequestError } from "@/utils/request";
import type { ResultAsync } from "@/utils/result";

export type RemoveCartResponse = string;
export type RemoveCartError = RequestError;

export function removeFromCart(data: BodyInit): ResultAsync<RemoveCartResponse, RemoveCartError>;
export function removeFromCart(url: string | null, data: BodyInit, headers?: HeadersInit): ResultAsync<RemoveCartResponse, RemoveCartError>;
export function removeFromCart(url: string | BodyInit | null, data?: BodyInit, headers?: HeadersInit) {
    if (!data) {
        data = url as BodyInit;
        url = null;
    }
    if (typeof url !== 'string') {
        url = window.themeConfig.urls.cart.remove;
    }

    return requestText(url, { method: 'POST', body: data, headers });
}
